/**
 * Formatters utility functions for currency and number formatting
 */

/**
 * Format a number as currency (KSH)
 * @param value Number to format
 * @returns Formatted currency string with KSh symbol
 */
export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('en-KE', {
    style: 'currency',
    currency: 'KES',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
};

/**
 * Format a number with thousand separators
 * @param value Number to format
 * @returns Formatted number string
 */
export const formatNumber = (value: number): string => {
  return new Intl.NumberFormat('en-KE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
};

/**
 * Format a percentage value
 * @param value Number to format as percentage
 * @param fractionDigits Number of decimal places to show
 * @returns Formatted percentage string
 */
export const formatPercentage = (value: number, fractionDigits: number = 1): string => {
  return new Intl.NumberFormat('en-KE', {
    style: 'percent',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  }).format(value / 100); // Convert from percentage value to decimal
};

/**
 * Format a date to a readable string
 * @param date Date to format
 * @returns Formatted date string
 */
export const formatDate = (date: Date | string): string => {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  
  return new Intl.DateTimeFormat('en-KE', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  }).format(date);
}; 